// extracted by mini-css-extract-plugin
export default {"upsellTitle":"XMIiIU","savingsBadge":"XzCocg","cycleName":"VpV9OM"};